import { useState } from 'react';

export function StylesFilter({ styles, onChange }) {
    const [checkedStyles, setCheckedStyles] = useState([]);

    const handleChange = (e) => {
        let newCheckedStyles = [...checkedStyles];
        if(e.target.checked) {
            newCheckedStyles.push(e.target.value);
        } else {
            newCheckedStyles = checkedStyles.filter((item) => e.target.name !== item);
        }
        setCheckedStyles(newCheckedStyles);
        onChange(newCheckedStyles);
    };

    return(
        <div className="filter">
          {styles.sort().map((style, index) => (
            <div key={index} className="filter-button">
                <input type="checkbox" name={ style } value={ style } onChange={handleChange} id={ style } />
                <label htmlFor={ style }>{ style }</label>
            </div>
          ))}
        </div>
    );
}